import { givenName } from "@/lib/names";

export type ChildGender = "boy" | "girl";

const BOYS_ENDING_A_OR_YA = new Set(["микола", "саша", "нікіта", "никита", "ілля", "добриня"]);

export function resolveGender(name: string, stored?: string | null): ChildGender {
  if (stored === "boy" || stored === "girl") return stored;
  return guessGender(name);
}

export function guessGender(fullName: string): ChildGender {
  const given = givenName(fullName).toLocaleLowerCase("uk-UA").replaceAll("ʼ", "'").replaceAll("’", "'");
  if (BOYS_ENDING_A_OR_YA.has(given)) return "boy";
  if (given.endsWith("а") || given.endsWith("я")) return "girl";
  return "boy";
}

export function absentWord(gender: ChildGender, capitalized = false) {
  const word = gender === "girl" ? "відсутня" : "відсутній";
  return capitalized ? word[0].toUpperCase() + word.slice(1) : word;
}

export function yourChildHeading(count: number, gender?: ChildGender) {
  if (count !== 1) return "Ваші діти";
  return gender === "boy" ? "Ваш син" : "Ваша донька";
}

type NameCase = "nom" | "gen" | "acc";

export function givenInCase(fullName: string, gender: ChildGender, form: NameCase): string {
  const given = givenName(fullName);
  if (form === "nom") return given;
  return gender === "girl" ? feminineCase(given, form) : masculineOblique(given);
}

export function joinGiven(
  people: Array<{ name: string; gender?: string | null }>,
  form: NameCase,
) {
  const names = people.map((person) =>
    givenInCase(person.name, resolveGender(person.name, person.gender), form),
  );
  const unique = [...new Set(names)];
  if (unique.length === 0) return "";
  if (unique.length === 1) return unique[0];
  return `${unique.slice(0, -1).join(", ")} і ${unique.at(-1)}`;
}

function feminineCase(name: string, form: "gen" | "acc") {
  const lower = name.toLocaleLowerCase("uk-UA");
  if (lower.endsWith("ія") || lower.endsWith("iя")) {
    return form === "gen" ? `${name.slice(0, -1)}ї` : `${name.slice(0, -1)}ю`;
  }
  if (lower.endsWith("я")) {
    return form === "gen" ? `${name.slice(0, -1)}і` : `${name.slice(0, -1)}ю`;
  }
  if (lower.endsWith("а")) {
    return form === "gen" ? `${name.slice(0, -1)}и` : `${name.slice(0, -1)}у`;
  }
  return name;
}

function masculineOblique(name: string) {
  const lower = name.toLocaleLowerCase("uk-UA");
  if (lower.endsWith("ій") || lower.endsWith("ий")) return `${name.slice(0, -1)}я`;
  if (lower.endsWith("о")) return `${name.slice(0, -1)}а`;
  if (lower.endsWith("ь")) return `${name.slice(0, -1)}я`;
  return `${name}а`;
}
